import axiosInstance from "../axiosInstance";

export const login = async (data) => {
  try {
    const response = await axiosInstance.post("/login", data);
    return response.data;
  } catch (error) {
    console.error("Error sending sign-up data", error);
    throw error;
  }
};

export const refreshToken = async () => {
  try {
    const savedUser = localStorage.getItem("userData");
    if (!savedUser) return null;

    const parsedUser = JSON.parse(savedUser);

    if (!parsedUser.refreshToken) return null;

    const response = await axiosInstance.post(
      "/refresh_token",
      { refreshToken: parsedUser.refreshToken },
      { withCredentials: true }
    );

    const refreshedData = response.data;

    const updatedUserData = {
      ...parsedUser,
      token: refreshedData.token,
      refreshToken: refreshedData.refreshToken,
    };

    localStorage.setItem("userData", JSON.stringify(updatedUserData));

    return updatedUserData;
  } catch (error) {
    console.error("Error refreshing token", error);
    return null;
  }
};

export const forgotPassword = async (data) => {
  try {
    const response = await axiosInstance.post("/forgot_password", data);
    return response.data;
  } catch (error) {
    console.error("Error sending sign-up data", error);
    throw error;
  }
};

export const resetPassword = async (data, token) => {
  try {
    const response = await axiosInstance.post("/reset_password", data, {
      headers: {
        Authorization: `Bearer ${token}`, // Set the resetToken in the headers for this request
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error sending reset password data", error);
    throw error;
  }
};

// export const verify = async (data) => {
//   try {
//     const response = await axiosInstance.post("/verify", data);
//     return response.data;
//   } catch (error) {
//     console.error("Error sending sign-up data", error);
//     throw error;
//   }
// };
